import refDataApi from '../api/ref-data.api'
// each Vuex instance is just a single state tree.
const state = {
  refereeList: [],
  stadiumList: null,
  rosterList: null,
  starList: null,
  sponsorList: null,
  nufflePrayerList: null
}

// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
const mutations = {
  updateRefereeList (state, refList) {
    state.refereeList = refList
  },
  updateStadiumList (state, stadiumList) {
    state.stadiumList = stadiumList
  },
  updateSponsorList (state, sponsorList) {
    state.sponsorList = sponsorList
  },
  updateNufflePrayerList (state, value) {
    state.nufflePrayerList = value
  }
}

// actions are functions that causes side effects and can involve
// asynchronous operations.
const actions = {
  getRefereeList (context) {
    refDataApi.api.getRefereeList()
      .then(response => {
        context.commit('updateRefereeList', response.data)
      },
      error => {
        console.log('impossible to load referee list from api: ')
        console.log(error)
      })
  },
  getStadiumList (context) {
    refDataApi.api.getStadiumList()
      .then(response => {
        context.commit('updateStadiumList', response.data)
      },
      error => {
        console.log('impossible to load stadium list from api: ')
        console.log(error)
      })
  },
  getSponsorList (context) {
    refDataApi.api.getSponsorList()
      .then(response => {
        context.commit('updateSponsorList', response.data)
      },
      error => {
        console.log('impossible to load stadium list from api: ')
        console.log(error)
      })
  },
  getNufflePrayersList (context) {
    refDataApi.api.getNufflePrayer()
      .then(response => {
        console.log('response')
        console.log(response)
        context.commit('updateNufflePrayerList', response.data)
      },
      error => {
        console.log('impossible to load nuffle prayers list from api: ')
        console.log(error)
      })
  }
}

// getters are functions
const getters = {
  refereeList: state => {
    return state.refereeList
  },
  stadiumList: state => {
    return state.stadiumList
  },
  sponsorList: state => {
    return state.sponsorList
  },
  refereeListForClub: state => clubId => {
    if (state.refereeList === null) {
      return null
    }
    let filteredreferees = state.refereeList.filter(ref => { return ref.club_list.find(c => { return c === clubId }) })
    return filteredreferees
  },
  stadiumListForClub: state => clubId => {
    if (state.stadiumList === null) {
      return null
    }
    let filteredStadiums = state.stadiumList.filter(stad => { return stad.club_list.find(c => { return c === clubId }) })
    return filteredStadiums
  },
  stadiumTypeList: state => {
    if (state.stadiumList === null) {
      return null
    }
    return [...new Set(state.stadiumList.map(stad => { return stad.type }))]
  },
  sponsorListForClub: state => clubId => {
    if (state.sponsorList === null) {
      return null
    }
    let filteredSponsor = state.sponsorList.filter(sponsor => { return sponsor.club_list.find(c => { return c === clubId }) })
    return filteredSponsor
  },
  nufflePrayers: state => {
    return state.nufflePrayers
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}




// WEBPACK FOOTER //
// ./src/store/ref_data.js